import { Typography } from "@mui/material";
import React from "react";


function ErrorScreen(){


    return(
        <>
        
        <Typography variant="h3">
            404 Error Page Not Found
        </Typography>
        
        </>
    )
}


export default ErrorScreen;